/**
 * @flow
 * @relayHash 1ae52e05365c599352f812d70bb8e7a1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SquareLeaderboardResult_getSquareLeaderboardData$ref = any;
export type SquareLeaderboardResultRefetchQueryVariables = {|
  question_leaderboard_link: string
|};
export type SquareLeaderboardResultRefetchQueryResponse = {|
  +$fragmentRefs: SquareLeaderboardResult_getSquareLeaderboardData$ref
|};
export type SquareLeaderboardResultRefetchQuery = {|
  variables: SquareLeaderboardResultRefetchQueryVariables,
  response: SquareLeaderboardResultRefetchQueryResponse,
|};
*/


/*
query SquareLeaderboardResultRefetchQuery(
  $question_leaderboard_link: ID!
) {
  ...SquareLeaderboardResult_getSquareLeaderboardData_bddNh
}

fragment SquareLeaderboardResult_getSquareLeaderboardData_bddNh on Query {
  getSquareLeaderboardData(question_leaderboard_link: $question_leaderboard_link) {
    code
    message
    data {
      _id
      game_id
      event_id
      leaderboard_link
      rowarr
      colarr
      answers {
        _id
        guest_name
        guest_id
        square
        winner
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "question_leaderboard_link",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "question_leaderboard_link",
    "variableName": "question_leaderboard_link"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SquareLeaderboardResultRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "SquareLeaderboardResult_getSquareLeaderboardData",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SquareLeaderboardResultRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getSquareLeaderboardData",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "squareLeaderboardDataType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "square_question_type",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "game_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "event_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "leaderboard_link",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rowarr",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "colarr",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "answers",
                "storageKey": null,
                "args": null,
                "concreteType": "square_answer_type",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "square",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "winner",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SquareLeaderboardResultRefetchQuery",
    "id": null,
    "text": "query SquareLeaderboardResultRefetchQuery(\n  $question_leaderboard_link: ID!\n) {\n  ...SquareLeaderboardResult_getSquareLeaderboardData_bddNh\n}\n\nfragment SquareLeaderboardResult_getSquareLeaderboardData_bddNh on Query {\n  getSquareLeaderboardData(question_leaderboard_link: $question_leaderboard_link) {\n    code\n    message\n    data {\n      _id\n      game_id\n      event_id\n      leaderboard_link\n      rowarr\n      colarr\n      answers {\n        _id\n        guest_name\n        guest_id\n        square\n        winner\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b39ddc39dc1bf8cd309c8fad51764c96';
module.exports = node;
